module.exports = __webpack_public_path__ + "img/GQ.94d95bf1.svg";